
  

   <div  fxLayout="row wrap" fxLayoutAlign="space-between center" class="dialog-headline">
    <h2 mat-dialog-title ></h2>
    <button mat-icon-button mat-dialog-close>
        <mat-icon>close</mat-icon>
    </button>
</div>
<div  class="scrollingDiv" mat-dialog-content>
<mat-card  appCard style="box-shadow: 0px 6px 22px -8px rgba(0, 0, 0, 0.2)">
    <mat-card-header class="titree">
        {{label | translate }} 
    </mat-card-header>
    <mat-card-content class="card-content">
        
      <table class="table table-bordered">
        <tbody>
          <tr>
            <th class="table-active" width="40%" >Identifiant de la classification</th>
            <td>{{data.cateId}}</td>
          </tr>
          <tr>
            <th class="table-active">Nom de la classification</th>
            <td>{{data.cateNm}} </td>
          </tr>
          
  
          <tr>
            <th class="table-active">Nom de la classification en anglais</th>
            
            <td>{{data.cateNmEn}} </td>
            
          </tr>
  
  
          <tr>
            <th class="table-active">Description de la classification</th>
            <td>{{data.cateDesc}} </td>
          </tr>


          <tr>
            <th class="table-active">Mise en ligne O/N</th>
             
              <td>{{data.useYn}} </td>
      
          </tr>

          <tr>
            <th class="table-active">Date d'enregistrement
            </th>
         
              <td>{{data.regDt| date : 'dd/MM/yyyy '}} </td>
     
          
          </tr>

          <tr>
            <th class="table-active">Analyste/Coordinateur</th>
          
              <td>{{data.regerId}} </td>
      
          </tr>


          <tr>
            <th class="table-active">Date de la modification</th>
          
              <td>{{data.modDt| date : 'dd/MM/yyyy '}} </td>
     
          </tr>
          <tr>
            <th class="table-active">Chargé de la modification	</th>
          
              <td>{{data.moderId| date : 'dd/MM/yyyy '}} </td>
      
          </tr>
  
  

  
        </tbody>
      </table>
  
    </mat-card-content>
  
  </mat-card> 

  <br>
  <div>
    <table
  
    [dataSource]="dataSource2"
    
    mat-table
    matSort
    style="width: 100%"
  >
  <!-- <ng-container matColumnDef="action">
    <th *matHeaderCellDef mat-header-cell mat-sort-header>
     N°
    </th>
    <td *matCellDef="let d; let i = index;" mat-cell> {{i+1}}</td>
  </ng-container> -->
  
  
  
  
  
  <ng-container matColumnDef="attrNm">
    <th  *matHeaderCellDef mat-header-cell  >
     
     {{ "Nom de la spécification technique" | translate }}
    </th>
    <td  width="25%" *matCellDef="let d" mat-cell style="text-align: center;">
      
 {{ d.attrNm }}
      </td>
  </ng-container>

  <ng-container matColumnDef="dataType">
    <th  *matHeaderCellDef mat-header-cell  style="text-align: center;">
     
     {{ "Type de données" | translate }}
    </th>
    <td  width="25%" *matCellDef="let d" mat-cell style="text-align: center;">
      
 {{ d.dataType }}
      </td>
  </ng-container>

  <ng-container matColumnDef="attrLen">
    <th  *matHeaderCellDef mat-header-cell  style="text-align: center;" >
     
     {{ "Longueur de l'attribut" | translate }}
    </th>
    <td  width="25%" *matCellDef="let d" mat-cell style="text-align: center;">
      
 {{ d.attrLen }}
      </td>
  </ng-container> 
  
  
  
  
  
  <ng-container matColumnDef="regDt">
    <th *matHeaderCellDef mat-header-cell style="text-align: center;" >
      {{ "Date d'enregistrement" | translate }}
    </th>
    <td *matCellDef="let d" mat-cell  width="25%" style="text-align: center;" >{{ d.regDt | date : 'dd/MM/yyyy ' }}</td>
  </ng-container>
  
  

  
  
    <tr  *matHeaderRowDef="readColumns2" mat-header-row></tr>
    <tr  *matRowDef="let row; columns: readColumns2" mat-row></tr> 
    
     
  
  
    
  </table>
  <app-empty-list-container
  [list]="dataSource2.data"
  [withoutBorder]="true"
  ></app-empty-list-container>
  </div>

</div>